import React from "react"
import { modalOverlayStyle, modalContentStyle, primaryButtonStyle, secondaryButtonStyle } from "../styles/commonStyles"
import { COLORS, TYPOGRAPHY, SPACING } from "../constants/theme"

const Modal = ({
	isOpen,
	onClose,
	title,
	children,
	footer,
	size = "md", // 'sm', 'md', 'lg', 'xl'
}) => {
	if (!isOpen) return null

	const sizeMap = {
		sm: { minWidth: "300px", maxWidth: "400px" },
		md: { minWidth: "400px", maxWidth: "600px" },
		lg: { minWidth: "600px", maxWidth: "800px" },
		xl: { minWidth: "800px", maxWidth: "1000px" },
	}

	const contentStyle = {
		...modalContentStyle,
		...sizeMap[size],
	}

	const handleOverlayClick = (e) => {
		if (e.target === e.currentTarget) {
			onClose()
		}
	}

	return (
		<div style={modalOverlayStyle} onClick={handleOverlayClick}>
			<div style={contentStyle} onClick={(e) => e.stopPropagation()}>
				{/* Header */}
				{title && (
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							marginBottom: SPACING.md,
							paddingBottom: SPACING.sm,
							borderBottom: `1px solid ${COLORS.border}`,
						}}
					>
						<h3
							style={{
								margin: 0,
								fontSize: TYPOGRAPHY.fontSize.lg,
								fontWeight: TYPOGRAPHY.fontWeight.semibold,
								color: COLORS.gray800,
							}}
						>
							{title}
						</h3>
						<button
							onClick={onClose}
							style={{
								background: "none",
								border: "none",
								fontSize: TYPOGRAPHY.fontSize["2xl"],
								cursor: "pointer",
								color: COLORS.gray500,
								padding: "4px",
								borderRadius: "4px",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
								<path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</button>
					</div>
				)}

				{/* Content */}
				<div style={{ marginBottom: footer ? SPACING.md : 0 }}>{children}</div>

				{/* Footer */}
				{footer && (
					<div
						style={{
							display: "flex",
							justifyContent: "flex-end",
							gap: SPACING.sm,
							paddingTop: SPACING.sm,
							borderTop: `1px solid ${COLORS.border}`,
						}}
					>
						{footer}
					</div>
				)}
			</div>
		</div>
	)
}

// Predefined Modal Components
export const ConfirmModal = ({
	isOpen,
	onClose,
	onConfirm,
	title = "Confirm Action",
	message,
	confirmText = "Confirm",
	cancelText = "Cancel",
	confirmVariant = "danger", // 'primary', 'danger', 'warning', 'success'
}) => {
	const getConfirmButtonStyle = () => {
		switch (confirmVariant) {
			case "danger":
				return { ...primaryButtonStyle, backgroundColor: COLORS.danger }
			case "warning":
				return { ...primaryButtonStyle, backgroundColor: COLORS.warning }
			case "success":
				return { ...primaryButtonStyle, backgroundColor: COLORS.success }
			default:
				return primaryButtonStyle
		}
	}

	const footer = (
		<>
			<button onClick={onClose} style={secondaryButtonStyle}>
				{cancelText}
			</button>
			<button onClick={onConfirm} style={getConfirmButtonStyle()}>
				{confirmText}
			</button>
		</>
	)

	return (
		<Modal isOpen={isOpen} onClose={onClose} title={title} footer={footer} size="sm">
			<p
				style={{
					margin: 0,
					color: COLORS.gray700,
					lineHeight: TYPOGRAPHY.lineHeight.normal,
				}}
			>
				{message}
			</p>
		</Modal>
	)
}

export default Modal
